import { render } from "./MetricsTable.vue?vue&type=template&id=1340b433&scoped=true"
import script from "./MetricsTable.vue?vue&type=script&lang=js"
export * from "./MetricsTable.vue?vue&type=script&lang=js"

import "./MetricsTable.vue?vue&type=style&index=0&id=1340b433&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1340b433"]])

export default __exports__